{
  "oktaAegisHost": "https://api.aegis.nikecloud.com",
  "oktaClientID": "nike.rcf.promote"
}
